import {CacheManager, CacheTypeEnumerate} from '@aofl/cache-manager';
import AnalyticsQueueException from '../AnalyticsQueueException';
/**
 *
 */
class AnalyticsQueue {
  /**
   *
   */
  static get STORAGE_KEY() {
    return 'event-queue';
  }

  /**
   * @param {String} storageNamespace
   * @param {Number} storageType
   */
  constructor(
    storageNamespace = 'analytics-queue',
    storageType = CacheTypeEnumerate.LOCAL
  ) {
    this.trackers = {};
    this.storage = new CacheManager(storageNamespace, storageType, 0);

    window.addEventListener('beforeunload', () => {
      this.sendQueue();
    });
  }

  /**
   * @return {Array}
   */
  getQueue() {
    let queue = this.storage.getItem(AnalyticsQueue.STORAGE_KEY);
    if (!queue) {
      return [];
    }

    return queue;
  }

  /**
   * @param {String} id
   * @param {Object} trackObject
   */
  track(id, trackObject) {
    if (this.trackers.hasOwnProperty(id)) {
      throw new AnalyticsQueueException(
        1000,
        `Duplicate key exception. A trackObject with ${id} id already exists`
      );
    }

    this.trackers[id] = trackObject;
    trackObject.init(this);
  }

  /**
   * @param {String} id
   */
  untrack(id) {
    if (!this.trackers.hasOwnProperty(id)) return;
    this.trackers[id].deInit();
    delete this.trackers[id];
  }

  /**
   * @param {Object} analyticsEvent
   */
  enqueueEvent(analyticsEvent) {
    let queue = this.getQueue();

    queue.push(analyticsEvent);
    this.storage.setItem(AnalyticsQueue.STORAGE_KEY, queue);
  }

  /**
   * @param {Function} cb
   */
  sendQueue(cb) {
    let queue = this.getQueue();
    if (!queue.length) return;

    this.storage.clear();
    new Promise(() => {
      return cb(queue);
    }).catch(() => {
      let tmpQueue = this.getQueue();
      for (let i = 0; i < queue.length; i++) {
        tmpQueue.push(queue[i]);
      }
      this.storage.setItem(AnalyticsQueue.STORAGE_KEY, tmpQueue);
    });
  }
}

export default AnalyticsQueue;



// WEBPACK FOOTER //
// ./analytics-queue/src/AnalyticsQueue/index.js